var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28168 6.71758C2.28168 6.71758 5.91657 2.6582 10.4004 2.6582C14.8843 2.6582 18.5192 6.71758 18.5192 6.71758",
    stroke: "#141B34",
    strokeWidth: 1.21781,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.149 10.8135C18.3958 11.1597 18.5192 11.3327 18.5192 11.5889C18.5192 11.845 18.3958 12.0181 18.149 12.3642C17.0399 13.9195 14.2075 17.272 10.4004 17.272C6.59337 17.272 3.761 13.9195 2.65192 12.3642C2.40509 12.0181 2.28168 11.845 2.28168 11.5889C2.28168 11.3327 2.40509 11.1597 2.65192 10.8135C3.761 9.25832 6.59337 5.90576 10.4004 5.90576C14.2075 5.90576 17.0399 9.25832 18.149 10.8135Z",
    stroke: "#141B34",
    strokeWidth: 1.21781
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8361 11.5889C12.8361 10.2438 11.7456 9.15332 10.4004 9.15332C9.05524 9.15332 7.96481 10.2438 7.96481 11.5889C7.96481 12.9341 9.05524 14.0246 10.4004 14.0246C11.7456 14.0246 12.8361 12.9341 12.8361 11.5889Z",
    stroke: "#141B34",
    strokeWidth: 1.21781
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.64c62a580a4561016c81fd0cbf1fa556.svg";
export { ForwardRef as ReactComponent };